import React from 'react'
import { View, TouchableOpacity, Text, Button } from 'react-native'
import BaseContext from './BaseContext.js'
import Styles from './Styles.js'

const GrammarTestCorrectAnswer = (props) => {
  return (
    <BaseContext.Consumer>
      {({state, dispatch}) => (
          <React.Fragment>
            <View style={Styles.grammarTestExplanationHeader}>
              <Text style={Styles.grammarTestCasePromptText}>Correct!</Text>
            </View>
            <View style={Styles.grammarTestExplanationBody}>
              <Text style={Styles.grammarTestAnswerExplanationText}>"{state.correctSentence}"</Text>
              <Text style={Styles.grammarTestAnswerExplanationText}>{state.explanation} case</Text>
            </View>
            <View style={Styles.grammarTestCaseContainer}>
              <Button title="Next question" onPress={ () => dispatch({type: 'REFRESH'})} />
            </View>
          </React.Fragment>
        )
      }
    </BaseContext.Consumer>
  )
}

export default GrammarTestCorrectAnswer
